export default function LoadingScreen({ label = 'Loading Weilink Signage…' }) {
  return <div className="loading-screen"><div className="brand-orb">WS</div><div className="loading-bar"><span /></div><p>{label}</p></div>;
}
